import "./App.css";

import LatestBlogs from "./components/latestBlogs";

function App() {
  return <LatestBlogs />;
}

export default App;
